@import 'src/styles/variabels';
@import 'src/styles/mobile';

.content {
  width: 100%;
  background-color: white;
}
.header {
  min-height: 6.4rem;
  padding: 1.8rem 35rem 1.7rem 2.4rem;
  box-shadow: 0 0 2.4rem 0 rgba(#000, 0.1);
  .title {
    font-size: 2.4rem;
    font-weight: normal;
    color: $color-grey-dark;
    text-transform: capitalize;
  }
}
.main {
  padding: 2rem;
}
.wrapper {
  display: grid;
  grid-template-columns: 23rem 1fr;
  border: 1px solid #eef0f2;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  .mainTabsNav {
    background: $color-grey-light;
    .link {
      border-top: 1px solid #eef0f2;
      color: $color-grey-dark;
      padding: 0.5rem 2rem;
      position: relative;
      &:last-child {
        border-bottom: 1px solid #eef0f2;
      }
      &.active {
        color: $color-primary;
        background: #fff;
        &:before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          width: 3px;
          background: $color-primary;
        }
      }
    }
    :global {
      .MuiList-root {
        padding: 1rem 0;
      }
    }
  }
  .rightSide {
    display: flex;
    :global {
      .data-grid {
        .toolbar-head {
          box-shadow: none;
          min-height: 0;
          padding: 1.7rem 2rem 1rem;
        }
      }
    }
  }
}

.mainBottomNav {
  display: flex;
  flex-direction: column;
  width: 6.4rem;
  :global {
    .MuiButtonBase-root {
      color: #fff;
      padding: 1rem;
    }
  }
}

// N2b (PD-10): a sectioned page (settings: labels, notebooks, general
// settings ...) below md. The desktop's 23 rem sub-page column took half of a
// 390 screen beside its grid; here the sub-pages are one row of the same
// links above the content, scrolling sideways (N1's scroll row, the fade as
// the cue), the current one underlined in the primary. The page's padding is
// the grid's own gutter (a card-mode grid carries it).
@media (max-width: map-get($breakpoints, 'md') - 1 + px) {
  .main {
    padding: 0;
  }
  .wrapper {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(0, 1fr);
    border: none;
    border-radius: 0;
    height: auto;
    min-height: 100%;
    overflow: visible;
    .mainTabsNav {
      height: auto;
      overflow-x: auto;
      overflow-y: hidden;
      overscroll-behavior-x: contain;
      scrollbar-width: none;
      background: #fff;
      border-bottom: 1px solid #eef0f2;
      @include mobile-scroll-fade;
      &::-webkit-scrollbar {
        display: none;
      }
      :global(.MuiList-root) {
        display: flex;
        flex-wrap: nowrap;
        width: max-content;
        padding: 0 $mobile-gutter;
      }
      .link {
        flex: none;
        min-height: $mobile-tap;
        padding: 0 $mobile-space-m;
        border-top: none;
        white-space: nowrap;
        &:last-child {
          border-bottom: none;
        }
        &.active {
          background: transparent;
          &:before {
            top: auto;
            right: 0;
            width: auto;
            height: 2px;
          }
        }
      }
      :global(.MuiListItemText-root) {
        margin: 0;
      }
      :global(.MuiListItemText-primary) {
        font-size: $mobile-font-tab;
      }
    }
    .rightSide {
      min-width: 0;
    }
  }
}
